import { ApolloClient, InMemoryCache, HttpLink, from } from "@apollo/client";
import { onError } from "@apollo/client/link/error";

const EVAL_DASHBOARD_API =
  import.meta.env.VITE_EVAL_DASHBOARD_API || "/evaluation-dashboard/graphql";
const APP_NAME = import.meta.env.VITE_APP_NAME || "evaluation-dashboard";

// Error handling link
const errorLink = onError(({ networkError, graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`,
      );
    });
  }
  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});

// Custom HTTP link with authentication headers
const httpLink = new HttpLink({
  uri: EVAL_DASHBOARD_API,
  fetch: (uri, options) => {
    options = options || {};
    options.headers = options.headers || {};

    // Include cookies for authentication
    options.credentials = "include";

    // Get org ID from localStorage or default
    const orgId =
      localStorage.getItem("orgId") ||
      import.meta.env.VITE_DEFAULT_ORG_ID ||
      "1";

    // Add required headers
    options.headers = {
      ...options.headers,
      "x-app-name": APP_NAME,
      "x-org-id": orgId,
      "content-type": "application/json",
      "apollo-require-preflight": "true",
    };

    return fetch(uri, options);
  },
});

// Create Apollo Client
export const apolloClient = new ApolloClient({
  link: from([errorLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          performanceDetails: {
            keyArgs: ["filter"],
            merge(existing, incoming, { args }) {
              if (!existing || !args?.after) {
                return incoming;
              }
              return {
                ...incoming,
                edges: [...existing.edges, ...incoming.edges],
              };
            },
          },
          evaluations: {
            keyArgs: ["filter"],
            merge(existing, incoming, { args }) {
              if (!existing || !args?.after) {
                return incoming;
              }
              return {
                ...incoming,
                edges: [...existing.edges, ...incoming.edges],
              };
            },
          },
        },
      },
      Evaluation: {
        keyFields: ["id"],
      },
      PerformanceMetrics: {
        keyFields: ["personId"],
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "cache-and-network",
      errorPolicy: "all",
    },
    query: {
      fetchPolicy: "cache-first",
      errorPolicy: "all",
    },
  },
});
